import axiosPost from '../axiosPost';
import { AxiosPostBody } from '../../../types/AxiosPost';
import { UserCredentialsType, UsuarioType } from '../../../types/types';

type Args = UserCredentialsType & {
    dni: string
};

export const usuarioBasicosGet = async (arg: Args) => {
    const body: AxiosPostBody = {
        "service": "UsuarioBasicosGet",
        "params": {
            "usuarioNroDeDocumento": arg.dni
        }
    }

    const result = await axiosPost<UsuarioType>('Y', body, arg);
    return result.result
}